import { render, staticRenderFns } from "./originChannelIdList.vue?vue&type=template&id=6946edeb&scoped=true&"
import script from "./originChannelIdList.vue?vue&type=script&lang=js&"
export * from "./originChannelIdList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6946edeb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6946edeb')) {
      api.createRecord('6946edeb', component.options)
    } else {
      api.reload('6946edeb', component.options)
    }
    module.hot.accept("./originChannelIdList.vue?vue&type=template&id=6946edeb&scoped=true&", function () {
      api.rerender('6946edeb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/channel/list/originChannelIdList.vue"
export default component.exports